import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Next_Btn from "../common/common-btn/next-btn/Next_Btn";
import Prev_Btn from "../common/common-btn/prev-btn/Prev_Btn";
import "./Edit_Trip_Modal.css";
import { Context } from "../../utils/context";
import { Controller, useForm } from "react-hook-form";
import { getcabs, getLocation } from "../../utils/apis/master/Master";

import { components } from "react-select";
import classNames from "classnames";
import Success_Modal from "../success-modal/Success_Modal";
import { useNavigate } from "react-router-dom";
import { decodeId } from "../../utils/common";

const CustomControl = ({ children, ...props }) => {



  const Icon = props.selectProps.icon;

  return (
    <components.Control {...props}>
      {Icon && (
        <span className="select_icon_wrapper">
          <Icon className="select_icon" />
        </span>
      )}
      {children}
    </components.Control>
  );
};
const Edit_Trip_Modal = ({
  show,
  handleClose,
  tripData,
  handleChange,
  handleSave,
}) => {

  const [showModal, setShowModal] = useState(false);

  const {
    register, control, reset,
    handleSubmit, watch, setValue,
    formState: { errors },
  } = useForm();
  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);

  const [locations, setLocations] = useState();
  const [apiError, setApiError] = useState();
  const getAllLocations = async () => {
    const res = await getLocation();

    if (res?.success) {
      setLocations(await Select2Data(res?.data, "location_id"));
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }
  const [cabType, setCabType] = useState();
  const getAllCabType = async () => {
    const res = await getcabs({ term: "" });

    if (res?.success) {
      setCabType(await Select2Data(res?.data, "cab_type_id"));
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }
  const resetFormData = async () => {
    await reset({
      trip_type: BookingData?.trip_type,

      pickup_location: {
        value: BookingData?.location_id,
        label: BookingData?.location?.name,
      },

      drop_location: BookingData?.destinationDescription || "",

      no_of_passenger: BookingData?.no_of_passenger,

      start_date: BookingData?.date
        ? new Date(BookingData?.date)
        : null,

      cab_type_id: {
        value: BookingData?.cab_id,
        label: BookingData?.cab_type?.name,
      },
    })
  }

  useEffect(() => {
    resetFormData()
    getAllCabType();
    getAllLocations();
  }, [show]);



  const pickupLocation = watch("pickup_location");
  const dropLocation = watch("drop_location");
  const cabTypeId = watch("cab_type_id");
  const selectedTripType = watch("trip_type");

  const filteredPickupLocations = locations?.filter(
    (loc) => loc.value !== dropLocation?.value
  );

  const getAmountOfTrip = async () => {

    const TripData = await getData(`/without-login/booking?location_id=${pickupLocation?.value || ""}&cab_type_id=${cabTypeId?.value || ""}&trip_type=${selectedTripType || ""}`);
    if (TripData?.success) {
      //   settripData(TripData?.data);
      setApiError("")
    } else {
      setApiError(TripData?.errors)
    }


  }

  useEffect(() => {
    getAmountOfTrip()
  }, [cabTypeId, pickupLocation, selectedTripType]);

  const onSubmit = async (data) => {

    if (apiError) {
      return;
    }
    console.log("Form Data:", data);
    const formData = new FormData();

    formData.append("no_of_passenger", data.no_of_passenger);
    formData.append("location_id", data.pickup_location?.value);
    formData.append("drop_location", data.drop_location);
    formData.append("trip_type", data.trip_type); // ✅ IMPORTANT

    formData.append("start_date", data.start_date);
    formData.append("cab_type_id", data.cab_type_id?.value);
    formData.append("id", BookingData?.id);

    const response = await postData(`/without-login/booking/step-1`, formData);
    if (response?.success) {
      setShowModal(true);

      setTimeout(() => {
        setShowModal(false);
        handleSave();
      }, 2500);
    } else {
      setApiError(response?.errors)
      console.error("Form submission failed:", response?.errors);
    }
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
      className="edit_trip_modal"
    >
      <Modal.Header>
        <Modal.Title className="edit_title">Edit Booking Details</Modal.Title>
        <div className="edit_close_btn" onClick={handleClose}>
          <FontAwesomeIcon icon={faXmark} style={{ color: "#FFFFFF" }} />
        </div>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col md={6} sm={6} className="mb-3">
              <Form.Group>
                <Form.Label>Trip Type</Form.Label>
                <div className="d-flex gap-3 ">

                  <Form.Check
                    className="edit_check"
                    type="radio"
                    label="Drop"
                    value="drop"
                    {...register("trip_type", {
                      required: "Please select type",
                    })}
                  />


                  <Form.Check
                    className="edit_check"
                    type="radio"
                    label="Return"
                    value="return"
                    {...register("trip_type")}
                  />
                </div>

                {errors?.trip_type && (
                  <span className="text-danger">{errors.trip_type.message}</span>
                )}
              </Form.Group>
            </Col>

            <Col md={6} sm={6} className="mb-3">
              <Form.Label>Pickup location</Form.Label>
              <Controller
                name="pickup_location"
                control={control}
                rules={{ required: "Plese Select Pickup location" }}
                render={({ field }) => (
                  // <Select
                  //   {...field}
                  //   options={filteredPickupLocations}
                  //   placeholder="Pick Up Location"
                  //   classNamePrefix="custom_select"
                  //   isSearchable
                  //   components={{ Control: CustomControl }}
                  //   icon={FaMapMarkerAlt}
                  //   value={field.value}
                  //   onChange={(val) => field.onChange(val)}
                  // />
                  <Select
                    {...field}
                    options={filteredPickupLocations}
                    value={field.value}
                    onChange={(val) => field.onChange(val)}
                    classNamePrefix="react-select"
                  />
                )}
              />
              {errors?.pickup_location && (
                <p className="text-danger mt-1 mb-0">
                  {errors?.pickup_location.message}
                </p>
              )}
            </Col>

            {/* <Row className="mb-3"> */}
            <Col md={6} sm={6} className="mb-3">
              <Form.Label>Drop Location</Form.Label>
              <Form.Control
                type="text"
                name="drop_location"
                placeholder="Drop Location..."
                classNamePrefix="custom_form_control"
                className={classNames("custom_form_control", {
                  "is-invalid": errors?.drop_location,
                })}
                {...register("drop_location", {

                })}
              />
              {errors?.drop_location && (
                <p className="text-danger mt-1">
                  {errors?.drop_location.message}
                </p>)}
            </Col>

            <Col md={6} sm={6} className="mb-3">
              <Form.Label>No. of Passengers</Form.Label>
              <Form.Control
                type="text"

                name="no_of_passenger"
                placeholder="No. of Passengers"
                classNamePrefix="custom_form_control"
                className={classNames("custom_form_control", {
                  "is-invalid": errors?.no_of_passenger,
                })}
                {...register("no_of_passenger", {
                  required: "Enter No. of Passengers",
                  min: {
                    value: 1,
                    message: "No. of Passengers cannot be less than 0",
                  },
                })}
                onKeyDown={(e) => {
                  if (
                    e.key === "-" || // Prevent negative sign
                    e.key === "+" || // Prevent plus sign
                    e.key === "e" || // Prevent scientific notation
                    e.key === "E" || // Prevent scientific notation
                    e.key === "." || // Prevent decimal point (if only integers allowed)
                    (isNaN(Number(e.key)) &&
                      e.key !== "Backspace" &&
                      e.key !== "Tab") // Allow only numbers, Backspace, and Tab
                  ) {
                    e.preventDefault();
                  }
                }}
              />

              {errors?.no_of_passenger && (
                <p className="text-danger mt-1">
                  {errors?.no_of_passenger.message}
                </p>
              )}
            </Col>

            {/* <Col md={6}>
              <Form.Group>
                <Form.Label>From - To</Form.Label>
                <Select
                  name="fromTo"
                  options={fromToOptions}
                  value={fromToOptions.find(
                    (option) => option.value === tripData.fromTo,
                  )}
                  onChange={handleSelectChange}
                  classNamePrefix="react-select"
                />
              </Form.Group>
            </Col> */}

            <Col md={6} sm={6} className="mb-3 custom_date_wrapper">
              <Form.Label>Trip Date</Form.Label>
              {/* <DatePicker
                selected={selectedDate}
                onChange={setSelectedDate}
                placeholderText="Select Date"
              /> */}

              <Controller
                name="start_date"
                control={control}
                rules={{ required: "Please Select Start date" }}
                render={({ field }) => {
                  const today = new Date();

                  // 👉 add 10 days
                  const minDate = new Date();
                  minDate.setDate(today.getDate() + 10);

                  return (
                    <DatePicker
                      placeholderText="Select Date"
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="dd/MM/yyyy"
                      minDate={minDate}
                      onKeyDown={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      isClearable
                    />
                  );
                }}
              />
              {errors?.start_date && (
                <p className="text-danger mt-1">
                  {errors?.start_date.message}
                </p>
              )}
            </Col>

            <Col md={6} sm={6}>
              <Form.Group>
                <Form.Label>Vehicle Type</Form.Label>

                <Controller
                  name="cab_type_id"
                  control={control}
                  rules={{ required: "Plese Select Vehicle type" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={cabType}
                      placeholder="Select Vehicle Type"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      components={{ Control: CustomControl }}
                      value={field.value}
                      onChange={(val) => field.onChange(val)}
                    />
                  )}
                />{errors?.cab_type_id && (
                  <p className="text-danger mt-1">
                    {errors?.cab_type_id.message}
                  </p>
                )}

              </Form.Group>
            </Col>

          </Row>

          <Row className="mb-3">
            <Col md={12}>
              <Form.Label>Occupancy</Form.Label>
              <Form.Control
                type="text"
                name="occupancy"
                value={`${BookingData?.cab_type?.seat_capacity?.name || "2"} passengers and 1 driver`}
              />
            </Col>
            {apiError && (
              <p className="advance_text text-danger">
                {apiError}
              </p>
            )}
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="both_btn_holder">
          <div onClick={handleClose}>
            <Prev_Btn text="Cancel" />
          </div>
          {/* <div onClick={handleSave}> */}
          <div onClick={handleSubmit(onSubmit)} >
            <Next_Btn text="Save Changes" />
          </div>
        </div>
      </Modal.Footer>

      <Success_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        successText="Step 1 Updated Of Booking"
      />
    </Modal>
  );
};

export default Edit_Trip_Modal;
